import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ProductDetaile.css";
import { useSelector } from "react-redux";
import { Carousel } from "react-bootstrap";

function ProductDetaile(props) {
  const post = useSelector((state) => state.galleryUID);
  let DilogBoxData=post.data?post.data[0]:null;
  if (typeof DilogBoxData === "undefined" || DilogBoxData===null) {
    DilogBoxData = {
      Artist: "",
      Details: "",
      Dimensions: "",
      HashTags: "",
      Name: "",
      Price: "",
      Qty: "",
      Type: "",
      UID: "",
      NoImages: 0,
    };
  }

  let ImageDisplay = [];
  for (let a = 0; a < DilogBoxData["NoImages"]; a++) {
    ImageDisplay.push(
      <Carousel.Item key={DilogBoxData["UID"] + "C" + (a + 1).toString()}>
        <img
          className="Photos02"
          src={
            // process.env.REACT_APP_BackEndIP+"/Static/Art/" +DilogBoxData["UID"] +"/" +(a + 1).toString() +".png"
            `${process.env.REACT_APP_BackEndIP}/Static/Art/${DilogBoxData["UID"]}/${(a + 1).toString()}.png?${new Date().getTime()}`
          
          }
          alt="Not Available"
        />
      </Carousel.Item>
    );
  }

  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" size="lg">
      <Modal.Header closeButton className="Titel02">
        <Modal.Title id="contained-modal-title-vcenter">
          {DilogBoxData["Name"]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ArtBox02">
        <div className="PhotosFrame02">
          <Carousel data-bs-theme="dark">{ImageDisplay}</Carousel>
        </div>
        <div className="TextFrame02">
          <p>
            <strong>Id: </strong>
            {DilogBoxData["UID"]}
            <br></br>
            <strong>Artist: </strong>
            {DilogBoxData["Artist"]}
            <br></br>
            <strong>Dimensions: </strong>
            {DilogBoxData["Dimensions"]}
            <br></br>
            <strong>Qty: </strong>
            {DilogBoxData["Qty"]}
            <br></br>
            <strong>Rs: </strong>
            {DilogBoxData["Price"]}
            <br></br>
            <strong>Details: </strong>
            {DilogBoxData["Details"]}
            <br></br>

            {/* <strong>Type: </strong>{DilogBoxData["Type"]}<br></br> */}
            {/* <strong>HashTag: </strong>{DilogBoxData["HashTags"]}<br></br> */}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductDetaile;
